<div class="d-flex align-items-center p-0" [style.display]="state.value === 'inactive' ? 'none' : ''">
  @if (toastIcon) {
    <span class="icon-container mr-3">
      <svg-icon [src]="toastIcon.src" [svgStyle]="{ 'fill': toastIcon.fill }"></svg-icon>
    </span>
  } @else {
    <div class="toast-icon mr-3">
      @if (toastPackage.toastType === 'toast-live-update') {
        <lib-icon icon="check-circle" [size]="30"></lib-icon>
      }
    </div>
  }


  <div>
    @if (title) {
      <div class="toast-title">{{title}}</div>
    }
    <div class="toast-message">{{message}}</div>
  </div>

  @if (options.closeButton) {
    <div
      (click)="remove()"
      class="toast-close ml-3"
      [style.visibility]="state.value === 'inactive' ? 'hidden' : 'visible'"
      >
      <lib-icon icon="x" [size]="20" [bold]="true"></lib-icon>
    </div>
  }
</div>
